import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { colors } from 'chime-ui/system';

import InvitedBy from 'components/InvitedBy';
import { LiveTimerPill } from 'components/LiveTimerPill';
import ProgressBar from 'components/ProgressBar';

import {
  IS_PAY_ANYONE_P2P,
  IS_REFERRAL_SPECIFIC_ENROLLMENT,
} from 'consts/appConsts';

import useRoutes from 'hooks/useRoutes';

import {
  Card,
  CardContainer,
  ChimeLogo,
  ChimeLogoOnly,
  PageWrapper,
} from 'styles/styleMixins';

import { chimeLoginLink, dismissToLogin } from 'utils/linkHelper';
import { IS_EMBEDDED, PAI_AMOUNT_QSP } from 'utils/queryParamHelpers';
import { trackLoginLinkTapped } from 'utils/segment/trackingEvents';
import { showUrgencyOfferContent } from 'utils/urgencyOfferUtils';

import { BoxShadowWrapper } from './components/BoxShadowWrapper';

export default function Layout({ children, renderFooter, routeObj = {} }) {
  const location = useLocation();

  const { index: pageNumber = -1 } = routeObj;

  const { activeRouteFlow } = useRoutes();

  const showP2pProgressBar =
    IS_PAY_ANYONE_P2P && !!PAI_AMOUNT_QSP && pageNumber > 0;

  const isSuccessPage = location.pathname === '/success';

  const showFirstPageHeader = pageNumber === 1;

  const shouldShowChimeLogoOnly =
    !showP2pProgressBar &&
    !IS_REFERRAL_SPECIFIC_ENROLLMENT &&
    !showFirstPageHeader;

  return (
    <PageWrapper>
      <Card>
        {showFirstPageHeader && (
          <FirstPageHeader>
            <ChimeLogoOnly />
            <LoginLink
              href={IS_EMBEDDED ? dismissToLogin : chimeLoginLink}
              onClick={() => {
                {
                  trackLoginLinkTapped();
                }
              }}
            >
              Log in
            </LoginLink>
          </FirstPageHeader>
        )}

        <CardContainer>
          {showP2pProgressBar && (
            <ProgressBar
              currentPageIndex={isSuccessPage ? '2' : pageNumber}
              totalPagesInFlow={activeRouteFlow.length}
            />
          )}

          {shouldShowChimeLogoOnly && <ChimeLogo />}

          {IS_REFERRAL_SPECIFIC_ENROLLMENT && (
            <BoxShadowWrapper>
              <InvitedBy />
            </BoxShadowWrapper>
          )}

          {showUrgencyOfferContent && <LiveTimerPill />}

          {children}
        </CardContainer>
      </Card>

      {!!renderFooter && renderFooter}
    </PageWrapper>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  routeObj: PropTypes.shape({
    index: PropTypes.number,
  }),
  renderFooter: PropTypes.node,
};

const FirstPageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;

  ${props => css`
    ${props.theme.media.mobileOnly`
        padding-top: 1rem;
      `};
  `};

  ${props => css`
    ${props.theme.media.desktop`
        padding:0 2rem;
      `};
  `};
`;

const LoginLink = styled.a`
  text-decoration: none;
  color: ${colors['content-action-primary']};
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
`;
